import { entity, list } from "./base";
import { concatModules } from "@/utility";

const initialEntity = {
  email: "",
  name: "",
  name_kana: null,
  permission_all: 0,
  permission_article: 0,
  permission_maker: 0,
  permission_user: 0
};

const adminModule = {
  actions: {
    emailCheck({ commit }, { email, excludedId = undefined }) {
      const store = this;
      return new Promise((resolve, reject) => {
        store.$axios
          .post(`/administrators/emailcheck`, {
            email,
            excludedId
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            commit("failed", { error });

            reject(error);
          });
      });
    }
  },
  getters: {}
};

const entityModule = entity("administrators", initialEntity);

export const administrators = {
  namespaced: true,
  modules: {
    list: list("administrators"),
    entity: concatModules(entityModule, adminModule)
  }
};
